import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ShoeIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 15c0-.6.4-1 1-1h5l3-3 3 .6c1.3.3 2.2.7 3.2 1.5l2.7 2.1c.6.5 1 .9 1 1.6 0 .9-.7 1.2-1.6 1.2H3a1 1 0 0 1-1-1v-2z" />
    <path d="M8 14l1.5 2M11 11.6l1.2 2.4" />
  </svg>
)
